import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

import { takeUntil } from 'rxjs';

import { AbstractComponent } from '../../shared/ui/abstract.component';

@Component({
  selector: 'placeme-spirit',
  templateUrl: './spirit.component.html',
  styleUrls: ['./spirit.component.scss'],
})
export class SpiritComponent extends AbstractComponent implements OnInit {
  showNavigation = true;

  constructor(private breakpointObserver: BreakpointObserver) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.breakpointObserver
      .observe(Breakpoints.XSmall)
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((state: BreakpointState) => {
        this.showNavigation = !state.matches;
      });
  }
}
